import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <main
      id="MainContent"
      className="content-for-layout focus-none"
      role="main"
      tabIndex={-1}
    >
      <div className="store-policy__container">
        <div className="store-policy__title">
          <h1>Refund policy</h1>
        </div>
        <div className="store-policy__body">
          <div className="rte">
            <h2>Limited Return Policy</h2>
            <p>
              Unused and unopened merchandise may be returned within 14 days of
              receiving your order. You will be responsible for all shipping
              costs unless you have received the wrong item, the item was
              damaged in shipping, or if the item is faulty.
            </p>
            <p>
              The approval of returns will be subject to the discretion of
              tunrisefield.
            </p>
            <p>
              You can always contact us for any return question at{" "}
              <a href="mailto:mall@tunrisefield.xyz">
                mall@tunrisefield.xyz
              </a>
              .
            </p>
            <p>
              <strong>Damages and issues</strong> <br />
              Please inspect your order upon reception and contact us
              immediately if the item is defective, damaged or if you receive
              the wrong item, so that we can evaluate the issue and make it
              right.
            </p>
            <p>
              <strong>Exceptions / non-returnable items</strong> <br />
              Unfortunately, we cannot accept returns on sale items or gift
              cards.
            </p>
            <h3 className="western">Return Process</h3>
            <p className="western">
              1. Email us at{" "}
              <a href="mailto:mall@tunrisefield.xyz">
                mall@tunrisefield.xyz
              </a>{" "}
              with the following information:
            </p>
            <ol>
              <li>
                <p>Order number:</p>
              </li>
              <li>
                <p>Name:</p>
              </li>
              <li>
                <p>Item(s) to return:</p>
              </li>
              <li>
                <p>Reason for return:</p>
              </li>
            </ol>
            <p className="western">2. Return the item</p>
            <p>
              If your return is approved, we will provide necessary shipping
              information and instructions needed to process your return. You
              will need to carefully package the items to ensure it is protected
              in shipment.
            </p>
            <p className="western">3. Finalizing your return</p>
            <p>
              We will notify you once we’ve received and inspected your return,
              and let you know if the refund was approved or not. If approved,
              you’ll be automatically refunded on your original payment method.
              We issue refunds for approved returns within 2 business days of
              receipt of the returned merchandise. Please remember it can take
              some time for your bank or credit card company to process and post
              the refund too.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Returns;
